import actionCreatorFactory, { Action } from 'typescript-fsa'
import { CollectionItem, Collection } from '../api/types'

const actionCreator = actionCreatorFactory('CollectionList')

// todo might pay to merge these two actions into a single async action
export interface CollectionItemsResult {
	id: number
	version: number
	language: string
	items: CollectionItem[]
	subtype: 'list' | 'tour' | 'menu' // parent collection subtype - so we know where to store results on redux
}
export const loadedCollectionItemsFromDisk = actionCreator<CollectionItemsResult>('LOADED_COLLECTION_ITEMS_FROM_DISK')

// triggers load of Collection from either Disk or Network
export interface RequestParams {
	id: number
	version: number
	accountId?: number
	language: string
	subtype: 'list' | 'tour' | 'menu' // parent collection subtype - so we know where to store results on redux
	// Ask for each item's screen alongside it. Only the single page tour layout needs them, and the
	// response carries the whole tour, so every other caller leaves this off.
	full?: boolean
}
export type LoadCollectionItemsParams = Action<RequestParams>
export const loadCollectionItems = actionCreator<RequestParams>('LOAD_COLLECTION_ITEMS')

export interface LoadCollectionDetailsPayload {
	id: number
	version: number
	accountId?: number
	language: string
}
export const loadCollectionDetails = actionCreator<LoadCollectionDetailsPayload>('LOAD_COLLECTION_DETAILS')

export interface CollectionDetailsResult {
	id: number
	version: number
	collection: Collection
	language: string
}
export type CollectionDetailsResultAction = Action<CollectionDetailsResult>
export const loadedCollectionDetailsFromDisk = actionCreator<CollectionDetailsResult>(
	'LOADED_COLLECTION_DETAILS_FROM_DISK',
)

export const clearLoadCollectionErrorAction = actionCreator<number>('CLEAR_LOAD_COLLECTION_ERROR')
